import { pickMaterialTheme } from '../cosmos'
export * from './hooks'
export const theme = pickMaterialTheme()
